import { KeyboardEvent, useCallback, useRef, useState } from "react";
import { useRouter } from "next/navigation";

import Tag from "./Tag";
import type { Tag as TagType } from "../../types";
const styles = new Proxy({"SearchBar":"SearchBar-d6b63","DropDown":"DropDown-d6b63","TagsClosed":"TagsClosed-d6b63"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const SearchBar = ({ tags }: { tags: TagType[] }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [toggle, setToggle] = useState(false);
  const router = useRouter();

  const onKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        if (!inputRef.current) {
          return;
        }

        const value = encodeURIComponent(inputRef.current.value);

        if (value) {
          inputRef.current.value = "";
          router.push(`/blog/1?search=${value}`);
        }
      }
    },
    [inputRef, router],
  );

  const onClick = useCallback(() => {
    setToggle((toggle) => !toggle);
  }, [setToggle]);

  const renderedTags = tags.map((tag) => <Tag key={tag.id} tag={tag} />);

  const tagStyle = ["col-12 col-md-8 mt-1", toggle || styles.TagsClosed].join(
    " ",
  );

  return (
    <div className={`row mb-2 ${styles.SearchBar}`}>
      <div className="col">
        <div className="row py-2 align-items-top">
          <div className="col-12 col-md-4 pb-2 pb-md-0">
            <div className="input-group">
              <input
                ref={inputRef}
                onKeyDown={onKeyDown}
                className="form-control border-0"
              />
              <span className="input-group-text border-0 bg-white">
                <i className="fa fa-search" />
              </span>
            </div>
          </div>
          <div className={tagStyle}>Tag filter: {renderedTags}</div>
        </div>
      </div>

      <div className="col-1">
        <button type="button" className={styles.DropDown} onClick={onClick}>
          {toggle ? (
            <i className="fa fa-caret-up" />
          ) : (
            <i className="fa fa-caret-down" />
          )}
        </button>
      </div>
    </div>
  );
};

export default SearchBar;
